import React, { useState } from "react";
import { ModalChiTiet } from "./ModalChiTiet";
import { getDate } from "../../../../utils/formatDate";
export const BtnChiTietNhanVien = ({ item }) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <a onClick={handleShow} href={() => false} className="blue btn-link text-left">
        {item.FirstName}
      </a>
      {handleClose && (
        <ModalChiTiet
          show={show}
          onHide={handleClose}
          tenNhanVien={item.FirstName}
          ngaySinh={getDate(item.BirthDay)}
          gioiTinh={item.Sex}
          cMTND={item.IDCard}
          diaChi={item.Address}
          phoneNumber={item.Phone}
          emailDangNhap={item.UserName}
          quyenChu={item.RoleName}
        />
      )}
    </>
  );
};
